{
  "dashboard": {
    "title": "Tableau de bord"
  },
  "devices": {
    "title": "Postes locaux S4"
  },
  "device": {
    "title": "Équipement"
  },
  "dtwins": {
    "title": "Équipements"
  },
  "dtwin": {
    "title": "Équipement LPP4"
  },
  "users": {
    "title": "Utilisateurs"
  },
  "user": {
    "title": "Utilisateur"
  },
  "profiles": {
    "title": "Profils"
  },
  "applications": {
    "title": "Applicatifs"
  },
  "campaigns": {
    "title": "Campagnes"
  },
  "logs": {
    "title": "Logs"
  },
  "sectors": {
    "details": {
      "title": "Détails du secteur {name}"
    },
    "title": "Secteurs"
  },
  "parameters": {
    "title": "Configuration"
  },
  "userGroups": {
    "title": "Groupes"
  },
  "pkiConnector": {
    "title": "Connecteur PKI"
  },
  "truststore": {
    "title": "Truststore"
  },
  "firmware": {
    "title": "Firmwares"
  },
  "filters": "Filtres",
  "certificateAlertReporting": {
    "title": "Reporting"
  },
  "certificate-management": {
    "title": "Certificats"
  },
  "applicationMgts": {
    "title": "Applications"
  },
  "license": {
    "title": "Licence"
  },
  "userAccount": {
    "title": "Compte utilisateur"
  },
  "about": {
    "title": "À propos",
    "downloadTitle": "Télécharger les logs"
  },
  "deviceConfiguration": {
    "title": "Configuration des équipements"
  },
  "certificates": {
    "title": "Certificats"
  },
  "fleets": {
    "title": "Flottes"
  },
  "businessUnits": {
    "title": "Modifier {name}"
  },
  "organizations": {
    "title": "Modifier {name}"
  },
  "interfaces": {
    "title": "Interfaces"
  }
}
